import { Component, ElementRef, OnInit } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ActivatedRoute } from '@angular/router';
import { ViewService } from './view.service';

declare var $: any;

@Component({
    selector: 'view-content',
    template: `<div #container></div>`,
    styleUrls: ['./view-content.component.scss'] 
  })
export class ViewContentComponent extends AdUtils {
  
  isMobile = false;

  ad: any = {};

  constructor(public elRef:ElementRef,
    private route: ActivatedRoute,
            srs : AdSearchService,
            gs : GeneralService,
            vs : ViewService){
    super(srs, gs, vs);
    this.isMobile =true;

    this.ad = {};
    this.idLoad = this.route.snapshot.paramMap.get('id');
    this.typeLoad = this.route.snapshot.data['type'];

  }

  setDefault(){}
  eventCallback(e){}

  
  

}  